<template>
    <!-- Registrations -->
    <div>
        <div class="registrations" v-if="!loading">
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col>
                            <h5 class="text-success mb-2 mt-2"><i class="far fa-users mr-3"></i>Registrations</h5>
                        </b-col>
                        <b-col class="text-right">
                            <b-button variant="success" size="sm" :href="apiUrl + 'api/conference/' + conference.id + '/export?auth=' + token" target="_blank"><i class="fas fa-file-excel mr-3"></i>Download CSV/Excel</b-button>
                        </b-col>
                    </b-row>
                </b-card-header>

                <b-tabs card>
                    <b-tab active>
                        <template v-slot:title><i class="far fa-users mr-2"></i>All
                            <b-badge variant="success">{{getRegByType(conference.registrations,'all').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'all')"/>
                        </b-card-text>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title><i class="far fa-exclamation-circle mr-2"></i>Pending
                            <b-badge variant="danger">{{getRegByType(conference.registrations,'pending').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'pending')"/>
                        </b-card-text>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title><i class="far fa-check-circle mr-2"></i>Complete
                            <b-badge variant="success">{{getRegByType(conference.registrations,'complete').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'complete')"/>
                        </b-card-text>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title><i class="far fa-credit-card mr-2"></i>Credit Card
                            <b-badge variant="success">{{getRegByType(conference.registrations,'cc').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'cc')"/>
                        </b-card-text>
                    </b-tab>
                    <b-tab class="reg-tab">
                        <template v-slot:title><i class="far fa-money-check-edit mr-2"></i>P.O.
                            <b-badge variant="success">{{getRegByType(conference.registrations,'po').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'po')"/>
                        </b-card-text>
                    </b-tab>
                    <b-tab class="reg-tab">
                        <template v-slot:title><i class="far fa-play mr-2"></i>Free
                            <b-badge variant="success">{{getRegByType(conference.registrations,'na').length}}</b-badge>
                        </template>
                        <b-card-text>
                            <registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'na')"/>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
        <div v-if="loading">
            <h5 class="text-muted"><i class="fas fa-spinner fa-pulse mr-3"></i>Loading registrations, please wait...</h5>
        </div>
    </div>
</template>

<script>
    import {apiUrl} from "../../../constants/config";
    import {mapActions, mapGetters} from 'vuex';
    import RegistrationRow from "../../../components/RegistrationRow";

    export default {
        name: "conference-details",
        components: {RegistrationRow},
        data() {
            return {
                loading: true,
                apiUrl: apiUrl
            }
        },
        methods: {
            ...mapActions(['getConferenceById', 'activateReg']),
            activate(reg) {
                reg.po_pending = 'false';
                this.activateReg(reg.code)
            },

            getRegByType(registrations, type) {
                return registrations.filter(reg => {
                    switch (type) {
                        case 'all':
                            return true;
                        case 'complete':
                            return (reg.payment_type === 'cc' || (reg.payment_type === 'po' && reg.po_pending === 'false'))
                        case 'pending':
                            return (reg.po_pending === 'true');
                        case 'cc':
                            return (reg.payment_type === 'cc');
                        case 'po':
                            return (reg.payment_type === 'po');
                        case 'na':
                            return (reg.payment_type === 'na');
                    }
                });
            }
        },
        computed: {
            ...mapGetters(['token', 'conference'])
        },
        mounted() {
            setTimeout(function () {
                this.loading = false;
            }.bind(this), 1000);
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }

    .registrations {
        .badge {
            padding: 0.3rem 0.4rem 0.2rem;
            margin-left: 0.3rem;
        }

        .registration {
            &:nth-child(odd) {
                background: #f8f9fa;
            }
        }
    }

</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .reg-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }

    .registrations {
        .nav-item {
            a {
                color: $success;
                font-size: 0.9rem;
            }
        }
    }

</style>
